import { useState } from "react";
import { ReceiptText } from "lucide-react";
import QrSlipUploadModal from "./QrSlipUploadModal";

export default function SlipUploadButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Upload slip"
        className="inline-flex items-center justify-center gap-1.5 text-[12px] font-medium w-9 h-9 sm:w-auto sm:h-auto sm:px-3 sm:py-1.5 rounded-[10px] transition-colors cursor-pointer bg-transparent text-[var(--text-secondary)] border border-border hover:bg-[var(--surface-muted)]"
      >
        <ReceiptText className="w-3.5 h-3.5" />
        <span className="hidden sm:inline">Upload slip</span>
      </button>
      {open && <QrSlipUploadModal onClose={() => setOpen(false)} />}
    </>
  );
}
